<template>
  <AboutTheProject />
</template>

<script setup lang="ts">
import { generatePageMetaLinks } from '~/core/seo'
import { AboutTheProject } from '~/features/about-the-project'

definePageMeta({
  layout: 'back-button',
})

watchEffect(() => {
  setPageLayout('back-button')
})

useHead({
  link: generatePageMetaLinks(),
})
</script>
